export default __webpack_public_path__ + "static/best-value-vpn-1531ad64349b62fb4168457d7bca42e5.svg";